// @ts-strict-ignore
import type { Module } from 'vuex'

import type { AuditState } from '../../models'

import { ResetAction } from '../common/actions/reset.action'
import { COMMON_CONSTS } from '../common/common.consts'
import { ResetMutation } from '../common/mutations/reset.mutation'

import { ReadAction } from './actions/read.action'
import { AUDIT_CONSTS } from './audit.consts'
import { DataGetter } from './getters/data.getter'
import { SetDataMutation } from './mutations/set-data.mutation'

export const AUDIT_MODULE: Module<AuditState, any> = {
  namespaced: true,

  initialState: (): AuditState => ({
    data: [],
  }),
  state: (): AuditState => AUDIT_MODULE.initialState(),

  getters: {
    [AUDIT_CONSTS.getters.data]: DataGetter.execute,
  },

  actions: {
    [AUDIT_CONSTS.actions.read]: ReadAction.execute,
    [COMMON_CONSTS.actions.reset]: context =>
      ResetAction.execute(context, AUDIT_MODULE.initialState()),
  },

  mutations: {
    [AUDIT_CONSTS.mutations.setData]: SetDataMutation.execute,
    [COMMON_CONSTS.mutations.reset]: ResetMutation.execute,
  },
}
